import { useEffect, useRef, useState } from "react";

// Isolate approved master typography from the app's Tailwind/reset stylesheet.
export const MasterSignaturePreview = ({ document, companyName }) => {
  const observer = useRef(null);
  const [height, setHeight] = useState(340);
  useEffect(() => () => observer.current?.disconnect(), []);

  const measure = (event) => {
    observer.current?.disconnect();
    const body = event.currentTarget.contentDocument?.body;
    if (!body) return;
    const resize = () => setHeight(Math.ceil(body.getBoundingClientRect().height) + 2);
    resize();
    observer.current = new ResizeObserver(resize);
    observer.current.observe(body);
  };

  return (
    <iframe
      data-testid="signature-preview-frame"
      title={`${companyName} signature preview`}
      srcDoc={document}
      sandbox="allow-same-origin allow-popups"
      onLoad={measure}
      className="block w-full border-0 bg-white"
      style={{ height }}
    />
  );
};
